import MagnifyingGlassIcon from './MagnifyingGlassIcon'

export default MagnifyingGlassIcon
